import { dayjs } from '../../common/momentExtends';
import { DataRecord } from './DataRecord';
export class HeaderRecord {
  build(furikomi_date: string) {
    this.furikomi_date = furikomi_date;
  }
  readonly data_kubun = '1'; // データ区分
  shubetsu_code = '21'; //業務種別 11または71 給与振り込み 12または72賞与振込
  readonly moji_code = '0'; // 0:JIS 1:EBCDIC
  readonly furikomi_irainin_code = '9009791709'; // 投稿が指定する１０桁の数字、利用申込書件手数料引き落とし依頼書に記載
  readonly furikomi_irainin_name = 'ｴﾇﾋﾟ-ｵ-ﾎｳｼﾞﾝ ｻｲﾚﾝﾄ ﾎﾞｲｽ';
  furikomi_date = dayjs().format('MMDD'); // 振り込み日を月日で指定1月23日の場合0123
  readonly target_bank_no = '0040'; // 仕向銀行番号
  readonly target_bank_name = 'ｲｵﾝ';
  target_bank_branch_no = '051'; // 振り込み依頼人の支店番号 -> sv
  target_bank_branch_name = 'ﾎﾝﾃﾝ'; // 任意 支店名 -> sv
  yokin_shumoku = '1'; // 預金種目
  kouza_bango = '0118667'; // ->
  readonly dummy = ''; // 17桁未使用

  toCSV() {
    return `${this.data_kubun},${this.shubetsu_code},${this.moji_code},${this.furikomi_irainin_code},${this.furikomi_irainin_name},${this.furikomi_date},${this.target_bank_no},${this.target_bank_name},${this.target_bank_branch_no},${this.target_bank_branch_name},${this.yokin_shumoku},${this.kouza_bango},${this.dummy}`;
  }
}

export class TrailerRecord {
  readonly data_kubun = '8'; // トレーラレコード
  sum_count = 0; // 振り込み合計件数
  sum_amount = 0; // 振り込み依頼合計金額
  dummy = ''; //ダミー　未使用x
  toCSV() {
    return `${this.data_kubun},${this.sum_count},${this.sum_amount},${this.dummy}`;
  }
}

export class EndRecord {
  readonly data_kubun = '9'; // エンドレコード
  dummy = ''; //ダミー 未使用
  toCSV() {
    return `${this.data_kubun},${this.dummy}`;
  }
}

export class FBRecordDTO {
  header = new HeaderRecord();
  data: DataRecord[] = [];
  trailer: TrailerRecord = new TrailerRecord();
  end: EndRecord = new EndRecord();
}
